<template>
  <div class="event-log-page">
    <div class="filter-box">
      <a-form layout="inline">
        <a-form-item>
          <a-input v-model="form.id" placeholder="请输入ID" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.title" placeholder="请输入标题关键字" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.message" placeholder="请输入内容关键字" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.receiver_username" placeholder="请输入收件人" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-range-picker
            v-model="form.dateRange"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始时间', '结束时间']"
            separator="至"
          />
        </a-form-item>
        <div v-show="isExpanded">
          <a-form layout="inline">
            <a-form-item>
              <a-select v-model="form.level" placeholder="请选择级别" allow-clear>
                <a-select-option value="DEBUG">DEBUG</a-select-option>
                <a-select-option value="INFO">INFO</a-select-option>
                <a-select-option value="WARN">WARN</a-select-option>
                <a-select-option value="ERROR">ERROR</a-select-option>
                <a-select-option value="CRITICAL">CRITICAL</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-input v-model="form.system" placeholder="请输入系统" allow-clear />
            </a-form-item>
            <a-form-item>
              <a-input v-model="form.module" placeholder="请输入模块" allow-clear />
            </a-form-item>
            <a-form-item>
              <a-input v-model="form.department" placeholder="请输入部门" allow-clear />
            </a-form-item>
          </a-form>
        </div>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
          <a-button @click="reset">重置</a-button>
          <a-button v-permission="PERMISSIONS.EVENT_LOG_EXPORT" @click="openExportModal">异步导出</a-button>
          <a-button @click="toggleExpand">{{ isExpanded ? '收起' : '展开' }}</a-button>
        </a-form-item>
      </a-form>
    </div>
    <vxe-table :border="true" :data="dataSource" :height="tableHeight" resizable :loading="loading">
      <vxe-column field="id" title="ID" width="120" />
      <vxe-column field="level" title="级别" width="100">
        <template #default="{ row }">
          <a-tag v-if="row.level === 'INFO'" color="green">{{ row.level }}</a-tag>
          <a-tag v-else-if="row.level === 'WARN'" color="orange">{{ row.level }}</a-tag>
          <a-tag v-else-if="row.level === 'ERROR' || row.level === 'CRITICAL'" color="red">{{ row.level }}</a-tag>
          <a-tag v-else>{{ row.level }}</a-tag>
        </template>
      </vxe-column>
      <vxe-column field="system" title="系统" />
      <vxe-column field="module" title="模块" />
      <vxe-column field="department" title="部门" />
      <vxe-column field="title" title="标题" min-width="200" show-overflow="tooltip" />
      <vxe-column field="receiver_username" title="收件人" max-width="150">
        <template #default="{ row }">
          <a-tooltip placement="top" :title="formatReceiver(row.receiver_username)">
            <div class="messagebox">{{ formatReceiver(row.receiver_username) }}</div>
          </a-tooltip>
        </template>
      </vxe-column>
      <vxe-column field="group_id" title="消息组" max-width="200">
        <template #default="{ row }">
          <a-tooltip placement="top" :title="getGroupName(row.group_id)">
            <div class="messagebox">{{ getGroupName(row.group_id) }}</div>
          </a-tooltip>
        </template>
      </vxe-column>
      <vxe-column field="create_time" title="创建时间" width="150" />
      <vxe-column field="ope" title="操作" width="100">
        <template #default="{ row }">
          <a-button size="small" @click="viewDetail(row)">查看详情</a-button>
        </template>
      </vxe-column>
    </vxe-table>
    <div class="pagination-wrapper">
      <a-pagination
        v-model="pagination.current"
        size="small"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :show-total="pagination.showTotal"
        @change="pageChange"
      />
    </div>
    <a-modal title="事件日志详情" :visible="detailDialogVisible" width="80%" :footer="null" :mask-closable="false" @cancel="detailDialogVisible = false">
      <div v-if="currentRow.id" class="event-log-detail">
        <div v-if="!currentRow.create_time" class="detail-loading">
          <a-icon type="loading" />
          <span>加载中...</span>
        </div>
        <div v-else>
          <a-descriptions title="消息属性" :column="2" bordered>
            <a-descriptions-item label="ID">{{ currentRow.id }}</a-descriptions-item>
            <a-descriptions-item label="级别">
              <a-tag v-if="currentRow.level === 'INFO'" color="green">{{ currentRow.level }}</a-tag>
              <a-tag v-else-if="currentRow.level === 'WARN'" color="orange">{{ currentRow.level }}</a-tag>
              <a-tag v-else-if="currentRow.level === 'ERROR' || currentRow.level === 'CRITICAL'" color="red">{{ currentRow.level }}</a-tag>
              <a-tag v-else>{{ currentRow.level }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="系统">{{ currentRow.system }}</a-descriptions-item>
            <a-descriptions-item label="模块">{{ currentRow.module }}</a-descriptions-item>
            <a-descriptions-item label="部门">{{ currentRow.department }}</a-descriptions-item>
            <a-descriptions-item label="创建时间">{{ currentRow.create_time }}</a-descriptions-item>
          </a-descriptions>
          <div class="detail-section-title">消息详情</div>
          <a-table :data-source="[currentRow]" bordered :show-header="false" :pagination="false">
            <a-table-column title="标题" data-index="title" :width="120">
              <template #default="text">
                <message-content mode="inline" :content="text" />
              </template>
            </a-table-column>
            <a-table-column title="消息" data-index="message">
              <template #default="text">
                <div class="message-cell">
                  <message-content mode="inline" :content="text" />
                  <a-button type="link" size="small" icon="fullscreen" @click="showMessageDetail(text)">展开</a-button>
                </div>
              </template>
            </a-table-column>
          </a-table>
          <div class="detail-section-title">通知历史</div>
          <a-table :data-source="currentRow.history_list" bordered :row-key="row => row.id" :pagination="false">
            <a-table-column title="通道名称" data-index="channel_name" />
            <a-table-column title="网关类型" data-index="gateway" />
            <a-table-column title="状态" data-index="status" width="100">
              <template #default="text">
                <a-tag v-if="text === 1" color="green">成功</a-tag>
                <a-tag v-else color="red">失败</a-tag>
              </template>
            </a-table-column>
            <a-table-column title="结果" width="200">
              <template #default="record">
                <a-popover placement="topLeft" :content="getContent(record)" trigger="hover">
                  <div class="messagebox">{{ getContent(record) }}</div>
                </a-popover>
              </template>
            </a-table-column>
            <a-table-column title="创建时间" data-index="create_time" />
            <a-table-column title="完成时间" data-index="done_time" />
          </a-table>
        </div>
      </div>
    </a-modal>
    <a-modal title="消息详情" :visible="messageDialogVisible" width="60%" :mask-closable="false" @cancel="messageDialogVisible = false">
      <div class="message-detail-content">
        <message-content :content="selectedMessage" />
      </div>
      <span slot="footer">
        <a-button @click="messageDialogVisible = false">关闭</a-button>
      </span>
    </a-modal>
    <a-modal title="导出" :visible="exportModalVisible" width="500px" @cancel="exportModalVisible = false" :after-close="resetExportParams">
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="导出文件名称">
          <a-input v-model="exportParams.exportFileName" />
        </a-form-item>
        <a-form-item label="导出保留天数">
          <a-input-number v-model="exportParams.exportFileKept" style="width: 100%" />
        </a-form-item>
      </a-form>
      <span slot="footer" class="dialog-footer">
        <a-button @click="exportModalVisible = false">取消</a-button>
        <a-button type="primary" @click="submitExportAsyncTask">确定</a-button>
      </span>
    </a-modal>
  </div>
</template>

<script>
import { fetchEventLogList, fetchEventLogDetail } from '@/api/monitor'
import { submitEventLogExportAsyncTask, fetchManagerGroup } from '@/api/notice'
import { message } from 'ant-design-vue'
import MessageContent from '@/components/MessageContent'

export default {
  components: { MessageContent },
  data() {
    return {
      dataSource: [],
      tableHeight: null,
      loading: false,
      detailDialogVisible: false,
      messageDialogVisible: false,
      selectedMessage: '',
      currentRow: {},
      exportModalVisible: false,
      groupOptions: [],
      isExpanded: false,
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      form: {
        id: '',
        level: undefined,
        system: '',
        module: '',
        department: '',
        title: '',
        message: '',
        receiver_username: '',
        dateRange: null
      },
      exportParams: {
        taskFunc: '事件日志导出',
        exportFileName: '事件日志.xlsx',
        exportFileKept: 30
      }
    }
  },
  created() {
    this.fetchData()
    this.fetchGroupOptions()
  },
  mounted() {
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  },
  methods: {
    fetchData(params = {}) {
      this.loading = true
      const query = {
        page_num: this.pagination.current,
        page_size: this.pagination.pageSize,
        ...this.buildQuery(),
        ...params
      }
      fetchEventLogList(query)
        .then(res => {
          this.loading = false
          if (res.code === 0) {
            this.dataSource = res.data.list
            this.pagination.total = res.data.total
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    buildQuery() {
      const query = {}
      if (this.form.id) {
        query.id = Number(this.form.id)
      }
      if (this.form.level) {
        query.level = this.form.level
      }
      if (this.form.system) {
        query.system = this.form.system
      }
      if (this.form.module) {
        query.module = this.form.module
      }
      if (this.form.department) {
        query.department = this.form.department
      }
      if (this.form.title) {
        query.title = this.form.title
      }
      if (this.form.message) {
        query.message = this.form.message
      }
      if (this.form.receiver_username) {
        query.receiver_username = this.form.receiver_username
      }
      if (this.form.dateRange && this.form.dateRange.length === 2) {
        query.start_time = this.form.dateRange[0]
        query.end_time = this.form.dateRange[1]
      }
      return query
    },
    search() {
      this.pagination.current = 1
      this.fetchData()
    },
    reset() {
      this.form = {
        id: '',
        level: undefined,
        system: '',
        module: '',
        department: '',
        title: '',
        message: '',
        receiver_username: '',
        dateRange: null
      }
      this.pagination.current = 1
      this.fetchData()
    },
    pageChange(e) {
      this.pagination.current = e
      this.fetchData()
    },
    viewDetail(row) {
      this.currentRow = { id: row.id }
      this.detailDialogVisible = true
      fetchEventLogDetail(row.id).then(res => {
        if (res.code === 0) {
          this.currentRow = res.data
        }
      })
    },
    showMessageDetail(message) {
      this.selectedMessage = message
      this.messageDialogVisible = true
    },
    calcTableHeight() {
      const pageHeight = window.innerHeight
      const headerHeight = 64
      const contentMargin = 48
      const contentPadding = 48
      const paginationHeight = 52
      const filterBox = document.querySelector('.event-log-page .filter-box')
      const filterHeight = filterBox ? filterBox.clientHeight : 52
      const extraGap = 0
      this.tableHeight = pageHeight - headerHeight - contentMargin - contentPadding - filterHeight - paginationHeight - extraGap
    },
    openExportModal() {
      this.exportModalVisible = true
    },
    submitExportAsyncTask() {
      const params = {
        ...this.buildQuery(),
        ...this.exportParams
      }
      submitEventLogExportAsyncTask(params).then(body => {
        message.success(`提交成功，任务编号为：${body.data.taskId}`)
        this.exportModalVisible = false
        this.resetExportParams()
      })
    },
    resetExportParams() {
      this.exportParams = {
        taskFunc: '事件日志导出',
        exportFileName: '事件日志.xlsx',
        exportFileKept: 30
      }
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded
      this.$nextTick(() => {
        this.calcTableHeight()
      })
    },
    fetchGroupOptions() {
      fetchManagerGroup({ page_num: 1, page_size: 500 }).then(res => {
        this.groupOptions = (res.data.list || []).map(item => ({ value: item.id, label: item.name }))
      })
    },
    formatReceiver(receiverUsername) {
      if (Array.isArray(receiverUsername) && receiverUsername.length > 0) {
        return receiverUsername.join(',')
      }
      return receiverUsername || ''
    },
    getGroupName(ids) {
      if (ids) {
        let str = ''
        this.groupOptions.map(group => {
          if (ids.indexOf(group.value) !== -1) {
            str = str + group.label + ','
          }
        })
        return str.replace(/,(\s+)?$/, '')
      } else {
        return ''
      }
    },
    formatGroupId(groupId) {
      if (Array.isArray(groupId) && groupId.length > 0) {
        return groupId.join(',')
      }
      return groupId || ''
    },
    getContent(row) {
      return `code: ${row.result?.errcode}; msg: ${row.result?.errmsg}`
    }
  }
}
</script>

<style scoped>
.event-log-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.filter-box {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.expand-filter {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}

.messagebox {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.message-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.message-cell .msg-content {
  flex: 1;
  min-width: 0;
}

/* 详情弹窗内的 a-table 统一固定布局：
   auto 布局下单元格 min-content 由内容决定，消息/结果/收件人 这类长文本会把表格撑出弹窗 */
.event-log-detail ::v-deep .ant-table table {
  table-layout: fixed;
}

.detail-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px 0;
  color: #909399;
  font-size: 14px;
}

.detail-loading i {
  font-size: 20px;
}

.message-detail-content {
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
  line-height: 1.6;
  max-height: 500px;
  overflow-y: auto;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  flex-shrink: 0;
}
</style>
